export default __webpack_public_path__ + "static/property-img-2_1400-b62702343011b29134af090ba9f916a1.jpg";